import { Stack } from "@mui/material";
import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
} from "react";
import { AssignessResourcesList } from "./AssignessResourcesList";
import { AssigneeScheduleTable } from "./AssigneeScheduleTable";

import { useAtom, useSetAtom } from "jotai";
import { useAtomCallback } from "jotai/utils";
import {
  apiAssignees,
  assigneeList,
  setAssigneeList,
  setCustomerIdAndServiceType,
  validateSchedule,
} from "../store/assigneeStore";
import {
  ApiAssigneeData,
  AssigneeTableData,
  IncomingAssigneeTableData,
  OnSubmitReturnType,
} from "../type/assigneeType";

type AssigneesMainFormProps = {
  tableData: IncomingAssigneeTableData[];
  customerId?: string;
  serviceType: "tickets" | "tasks" | "projects";
};

export type MainFormSubmitType = {
  handleSubmit: () => Promise<OnSubmitReturnType | false>;
};
export const AssigneesMainForm = forwardRef<
  MainFormSubmitType,
  AssigneesMainFormProps
>(({ tableData, customerId, serviceType }: AssigneesMainFormProps, ref) => {
  const validateScheduleArray = useSetAtom(validateSchedule);
  const assigneesData = useAtomCallback(
    useCallback((get) => {
      return {
        apiData: get(apiAssignees),
        tableData: get(assigneeList),
      };
    }, []),
  );
  const setAssigneeDataToStore = useSetAtom(setAssigneeList);

  const setCustomerIdandServiceTypeToStore = useSetAtom(
    setCustomerIdAndServiceType,
  );
  useEffect(() => {
    if (customerId) {
      setCustomerIdandServiceTypeToStore({ customerId, serviceType });
    }
  }, [customerId, serviceType]);

  useEffect(() => {
    if (tableData) {
      setAssigneeDataToStore(tableData);
    }
  }, [tableData]);

  const handleSubmit = async () => {
    const isValid = await validateScheduleArray();
    if (isValid) {
      return assigneesData();
    } else {
      return false;
    }
  };
  useImperativeHandle(ref, () => ({
    handleSubmit,
  }));
  return (
    <Stack direction={"row"} sx={{ height: "100%" }}>
      <AssignessResourcesList />
      <Stack
        sx={{
          flex: 1,
          height: "100%",
          overflowY: "scroll",
        }}
      >
        <AssigneeScheduleTable />
      </Stack>
    </Stack>
  );
});
